"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const VirtualizedListItems_1 = require("./VirtualizedListItems/VirtualizedListItems");
const KeyCodes_1 = require("../../constants/KeyCodes");
require("./List.scss");
const List = (0, react_1.forwardRef)(({ className, id, component = "ul", children, dense = false, ariaLabel, ariaDescribedBy, renderOnlyVisibleItems = false, style }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const [focusIndex, setFocusIndex] = (0, react_1.useState)(0);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const Component = component;
    const childrenRefs = (0, react_1.useRef)([]);
    const onKeyDown = (0, react_1.useCallback)((event) => {
        const isUpKey = event.keyCode === KeyCodes_1.keyCodes.UP_ARROW;
        const isDownKey = event.keyCode === KeyCodes_1.keyCodes.DOWN_ARROW;
        let overrideFocusIndex = undefined;
        if (isUpKey || isDownKey) {
            if (isDownKey && focusIndex + 1 < childrenRefs.current.length) {
                overrideFocusIndex = focusIndex + 1;
            }
            else if (isUpKey && focusIndex > 0) {
                overrideFocusIndex = focusIndex - 1;
            }
            event.preventDefault();
            if (overrideFocusIndex !== undefined) {
                setFocusIndex(overrideFocusIndex);
                childrenRefs.current[overrideFocusIndex].focus();
            }
        }
    }, [focusIndex]);
    const overrideChildren = (0, react_1.useMemo)(() => {
        let override = Array.isArray(children) ? children : [children];
        if (renderOnlyVisibleItems) {
            override = (0, jsx_runtime_1.jsx)(VirtualizedListItems_1.VirtualizedListItems, { children: override });
        }
        else {
            childrenRefs.current = childrenRefs.current.slice(0, override.length);
            override = react_1.default.Children.map(override, (child, index) => {
                if (!react_1.default.isValidElement(child)) {
                    return child;
                }
                return typeof child === "string"
                    ? child
                    : react_1.default.cloneElement(child, {
                        // @ts-ignore not sure how to deal with ref here
                        ref: ref => (childrenRefs.current[index] = ref),
                        tabIndex: focusIndex === index ? 0 : -1
                    });
            });
        }
        return override;
    }, [children, focusIndex, renderOnlyVisibleItems]);
    return (
    // @ts-ignore Component comes from string, so it couldn't have types
    (0, jsx_runtime_1.jsx)(Component, Object.assign({ ref: mergedRef, style: style, onKeyDown: !renderOnlyVisibleItems ? onKeyDown : undefined, className: (0, classnames_1.default)("monday-style-list", className, {
            "monday-style-list--dense": dense,
            "monday-style-list-container": renderOnlyVisibleItems
        }), id: id, "aria-label": ariaLabel, "aria-describedby": ariaDescribedBy, tabIndex: -1 }, { children: overrideChildren })));
});
exports.default = List;
